"use client";

import { v2Fetch } from "./client";

export type Scope = 0 | 1 | 2;

export interface WorkflowInstruction {
  id: string;
  companyId: string;
  workflowId: string;
  scope: Scope;
  targetGroupId: string | null;
  targetUserId: string | null;
  content: string;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertWorkflowInstructionBody {
  workflowId: string;
  scope: Scope;
  targetGroupId?: string | null;
  targetUserId?: string | null;
  content: string;
}

export function v2ListWorkflowInstructions(
  workflowId: string,
): Promise<WorkflowInstruction[]> {
  return v2Fetch<WorkflowInstruction[]>(
    `/api/v2/workflow-instructions?workflowId=${encodeURIComponent(workflowId)}`,
  );
}

export function v2UpsertWorkflowInstruction(
  body: UpsertWorkflowInstructionBody,
): Promise<{ instruction: WorkflowInstruction | null }> {
  return v2Fetch(`/api/v2/workflow-instructions`, {
    method: "PUT",
    body: JSON.stringify(body),
  });
}
